var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import update from "immutability-helper";
import * as actionTypes from "../constants/actionTypes";

var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: {},
  results: {
    sections: [],
    specialFeatures: []
  }
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case actionTypes.GET_SECTIONS:
      {
        return _extends({}, state, {
          isLoading: true
        });
      }

    case actionTypes.GET_SECTIONS_SUCCESS:
      {
        var newState = _extends({}, state, {
          isFinished: true,
          isLoading: false,
          isError: false
        });

        return update(newState, {
          results: {
            $merge: {
              sections: action.payload
            }
          }
        });
      }

    case actionTypes.SET_SECTION:
      {
        return _extends({}, state, {
          data: _extends({}, state.data, {
            section: action.section
          })
        });
      }

    case actionTypes.GET_SECTION_SUCCESS:
      return _extends({}, state, {
        data: _extends({}, state.data, {
          section: action.payload
        })
      });

    case actionTypes.SET_LAST_SEEN:
      {
        return _extends({}, state, {
          data: _extends({}, state.data, {
            lastSeen: action.lastSeen
          })
        });
      }

    case actionTypes.GET_SECTIONS_ERROR:
      {
        return _extends({}, state, {
          isError: true,
          isLoading: false,
          isFinished: true,
          error: action.payload
        });
      }

    case actionTypes.GET_SPECIAL_FEATURES:
      {
        return _extends({}, state, {
          isLoading: true
        });
      }

    case actionTypes.GET_SPECIAL_FEATURES_SUCCESS:
      {
        var _newState = _extends({}, state, {
          isFinished: true,
          isLoading: false,
          isError: false
        });

        return update(_newState, {
          results: {
            $merge: {
              specialFeatures: action.payload
            }
          }
        });
      }

    case actionTypes.GET_SPECIAL_FEATURES_ERROR:
      {
        return _extends({}, state, {
          isError: true,
          isLoading: false,
          isFinished: true,
          error: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
});


// WEBPACK FOOTER //
// ./src/reducers/navigation.js